import { useState, useEffect } from 'react';
import { Cell, Legend, Pie, PieChart, Tooltip } from "recharts";
import Modal from '../../../../common/Modals/Modal/Modal';
import Button from '../../../../common/Button/Button';
import './CalculatorModal.scss';

const CalculatorModal = ({ show, handleClose }) => {
    const [monthly, setMonthly] = useState(806);
    const [rate, setRate] = useState(12);
    const [time, setTime] = useState(10);
    const [investmentAmount, setInvestmentAmount] = useState(0);
    const [estimatedReturns, setEstimatedReturns] = useState(0);
    const [totalValue, setTotalValue] = useState(0);
    const calculateSIP = () => {
        const P = monthly;
        const n = time * 12;
        const r = rate / 100 / 12;
        const maturityValue = P * (((Math.pow(1 + r, n) - 1) / r) * (1 + r));
        const invested = P * n;
        setInvestmentAmount(invested);
        setEstimatedReturns(Math.round(maturityValue - invested));
        setTotalValue(Math.round(maturityValue));
    };

    // auto recalc when sliders move
    useEffect(() => {
        calculateSIP();
    }, [monthly, rate, time]);

    const data = [
        { name: "Investment Amount", value: investmentAmount },
        { name: "Est. Returns", value: estimatedReturns }
    ];

    const COLORS = ["#787FFF", "#cacc3fff"];

    return (
        <Modal show={show} handleClose={handleClose} className="calculator" title='Portfolio Calculator'>
            <div className='calculator_innerSec'>
                <div className="sipContainer">

                    <div className="sliderRow">
                        <div className='sidelabel'>
                            <label>Monthly Investment</label>
                            <h3>${monthly}</h3>
                        </div>
                        <input type="range" min="500" max="5000"
                            value={monthly}
                            onChange={(e) => setMonthly(Number(e.target.value))} />
                    </div>

                    <div className="sliderRow">
                        <div className='sidelabel'>
                            <label>Expected Return Rate (p.a)</label>
                            <h3>{rate}%</h3>
                        </div>
                        <input type="range" min="5" max="20"
                            value={rate}
                            onChange={(e) => setRate(Number(e.target.value))} />
                    </div>

                    <div className="sliderRow">
                        <div className='sidelabel'>
                            <label>Time Period</label>
                            <h3>{time} yr</h3>
                        </div>
                        <input type="range" min="1" max="30"
                            value={time}
                            onChange={(e) => setTime(Number(e.target.value))} />
                    </div>

                    <div className="chartBox">
                        <PieChart width={656} height={190}>
                            <Pie data={data} dataKey="value" innerRadius={55} outerRadius={100} paddingAngle={3}>
                                {data.map((entry, index) => (
                                    <Cell key={index} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip />
                            <Legend verticalAlign="middle" align="right" layout="vertical" />
                        </PieChart>
                    </div>

                    <div className="infoBox">
                        <div className="row"><label>Investment Amount</label><h6>${investmentAmount.toLocaleString()}</h6></div>
                        <div className="row"><label>Est. Returns</label><h6>${estimatedReturns.toLocaleString()}</h6></div>
                        <div className="row total"><label>Total Value</label><h6>${totalValue.toLocaleString()}</h6></div>
                    </div>

                    {/* <Button fluid className="investBtn">
                        Invest Now
                    </Button> */}

                </div>
            </div>
        </Modal>
    );
};

export default CalculatorModal;
